import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import autobind from 'class-autobind';

import { didComponentValueUpdate } from 'zoomforth_zfutils/react_helpers.js';

const DEFAULT_TIMER_MS = 500;
class TimedInputBase extends Component {

  constructor(props) {
    super(props);

    this.state = {
      value: props.value
    };

    this.onChangeTimer = null;

    autobind(this);
  }

  handleChange(syntheticEvent) {
    window.clearTimeout(this.onChangeTimer);
    const e = syntheticEvent.nativeEvent;

    this.setState({ value: this.props.getOnChangeValue(e) });

    if(this.props.onEveryChange){
      this.props.onEveryChange(e);
    }

    this.onChangeTimer = setTimeout(() => {
      this.props.onChange(e);
    }, this.props.onChangeTimerMs);
  }

  componentDidUpdate(prevProps, prevState) {
    if(didComponentValueUpdate(this.props.value, prevProps.value)){
      this.setState({ value: this.props.value });
    }
  }

  render() {
    const { value } = this.state;

    return (
      <Fragment>
        {
          // pass the props to children
          React.cloneElement(this.props.children, { 
            onChange: this.handleChange, 
            value 
          })
        }
      </Fragment>
    );
  }

}

TimedInputBase.defaultProps = {
  onChangeTimerMs: DEFAULT_TIMER_MS,
};

TimedInputBase.propTypes = {
  value: PropTypes.any,
  getOnChangeValue: PropTypes.func.isRequired,
  onEveryChange: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onChangeTimerMs: PropTypes.number
};

export default TimedInputBase;